export { default } from './Press';
